import { useEffect, useRef, useState } from "react";
import { useConfiguration } from "../../../contexts/ConfigurationContext";
import axios from "axios";

interface FetchTranscriptDataProps {
    showTranscriptSettings: boolean;
}

interface TranscriptionData {
    entries: any;
    language: string;
    translationLanguages?: string[];
    translations?: any[]
}

export const useFetchTranscriptData = ({ showTranscriptSettings }: FetchTranscriptDataProps): { transcriptions?: TranscriptionData } => {
    const { currentMediaId, accountId, mediasData, setTranscriptions: setTranscriptionsAction } = useConfiguration();

    const [transcriptions, setTranscriptions] = useState<TranscriptionData | undefined>(undefined);
    const lastFetchedKeyRef = useRef<string | null>(null);

    useEffect(() => {
        if (!showTranscriptSettings) {
            return;
        }

        const fetchingMediaId = mediasData.find(m => m.originalId === currentMediaId)?.id || currentMediaId;
        const fetchKey = `${accountId}:${fetchingMediaId}`;
        if (lastFetchedKeyRef.current === fetchKey) {
            return;
        }

        if (fetchingMediaId && accountId) {
            const transcriptionUrl = `https://video.qbrick.com/api/v1/text/public/accounts/${accountId}/medias/${fetchingMediaId}/transcription`;

            axios.get(transcriptionUrl).then((response) => {
                lastFetchedKeyRef.current = fetchKey;
                if (response?.data) {
                    const translationLanguages = Object.keys(response.data.translations || {});
                    const transcriptionData: TranscriptionData = {
                        ...(response.data || {}),
                        translationLanguages
                    };
                    setTranscriptionsAction(transcriptionData);
                    setTranscriptions(transcriptionData);
                } else {
                    setTranscriptionsAction({});
                    setTranscriptions(undefined);
                }
            }).catch(() => {
                lastFetchedKeyRef.current = fetchKey;
                setTranscriptionsAction({});
                setTranscriptions(undefined);
            });
        } else {
            setTranscriptionsAction({});
            setTranscriptions(undefined);
        }
    }, [accountId, currentMediaId, showTranscriptSettings, mediasData]);

    return { transcriptions };
}